import { styled } from '@compiled/react';
import { layers } from '@jira/platform__ui-layers';
import { token } from '@atlaskit/tokens';
import type {
	ElementStyles,
	SelectElementState,
} from '@atlassian/jira-common-components-picker/src/model.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OptionContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OptionLabel = styled.span({
	marginLeft: token('space.100'),
	flexGrow: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	color: token('color.text.brand'),
	paddingTop: token('space.075'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.075'),
	paddingLeft: token('space.150'),
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
	},
	'&:active': {
		backgroundColor: token('color.background.neutral.subtle.pressed'),
	},
});

// feel free to remove these styles once ak/select supports footer option
export const selectFooterStyles = {
	option: (base: ElementStyles, state: SelectElementState): ElementStyles => {
		const akSelectMenuPaddingBottom = token('space.100');
		const akSelectMenuPaddingBottomOffset = token('space.negative.100');

		return {
			...base,

			// apply styles only for 'Create new' option: https://github.com/JedWatson/react-select/issues/3377

			...(state.data.__isNew__ === true
				? {
						...(state.isFocused
							? {
									'> .issue-view__select-footer': {
										backgroundColor: token('color.background.neutral'),
									},
								}
							: {}),

						position: 'sticky',
						bottom: 0,
						backgroundColor: `${token('elevation.surface')} !important`,

						// N900, hex does not work with rgba()
						borderTop: `2px solid ${token('color.border')}`,

						padding: 0,
						paddingTop: token('space.100'),

						// resetting 'padding' alone does not work in this component's case
						paddingBottom: 0,

						// to ensure that :after element is shown even though it's outside of the main one
						overflow: 'visible',

						':after': {
							// need this element to avoid having another option part being shown below Create one on scrolling (it is shown because options list element has padding)
							content: '""',
							display: 'block',
							position: 'absolute',
							bottom: akSelectMenuPaddingBottomOffset,
							left: 0,
							width: '100%',
							height: akSelectMenuPaddingBottom, // to have same footer height both when list scrolling is at the top and at the very bottom.
							backgroundColor: token('elevation.surface'),
							borderBottomLeftRadius: token('radius.small'), // need to match menu's border-radius, not to hide menu's border
							borderBottomRightRadius: token('radius.small'),
						},
					}
				: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					({} as ElementStyles)),

			...(state.data.isAkSelectOption === true
				? {
						textAlign: 'center',
						paddingTop: token('space.100'),
						paddingBottom: token('space.200'),
					}
				: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					({} as ElementStyles)),
		};
	},
	menu: (base: ElementStyles) => ({
		...base,
		// without properly set zIndex value dropdown with options is shown behind the action buttons
		zIndex: layers.modal,
	}),
} as const;
